import { useRef } from "react";

export const useSelectFocus = () => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFocusInput = () => inputRef.current?.focus();

  return { handleFocusInput, inputRef };
};
